module.exports = __webpack_public_path__ + "account/img/47.ba86aa89.png";